import script from "./CarFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./CarFilter.vue?vue&type=script&setup=true&lang=js"

import "./CarFilter.vue?vue&type=style&index=0&id=3faf8eaa&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3faf8eaa"]])

export default __exports__